import 'cropperjs';
import 'jquery-cropper';
import Alpine from 'alpinejs'

// Alpine.jsの設定
Alpine.start()
window.Alpine = Alpine

require('../bootstrap');
// plugins
require('../../plugins/image-map');
require('../../plugins/jsQR');
require('../../plugins/jquery.qrcode.min');
require('../../plugins/select2/js/select2.min');
require('../../plugins/select2/js/i18n/ja');
require('../../plugins/sweetalert2.all.min');
// common
require('../common/file_upload');
require('../common/table_link');
// company
require('./user');
require('./news');
require('./event');
require('./preview');
// member
require('../member/register');

(function() {
  "use strict";

  /**
   * js エラーをサーバーに送信
   */
  window.handleError = function(err) {
    try {
      console.dir(err);
      err['URL'] = location.href;
      err['UA'] = window.navigator.userAgent;
      var params = jQuery.map(err, function(v, k) {
        return k + '=' + encodeURIComponent(v);
      }).join('&');

      new Image().src = '/error/js?'+ params;
    } catch (ex) {
      console.dir(ex);
    }
    return false;
  };

  window.addEventListener('error', function(e) {
    console.log("window.addEventListener('error')");
    handleError({
      MSG: e.message,
      FILE: e.filename + '('+e.lineno+':'+e.colno+')'
    });
  });
})();
